import React, { useCallback, useState } from 'react';
import { Flex, Typography } from '@banhala/ui-kit';
import { useGoodsReportable } from '../../queries/useGoodsReportable';
import { useReportGoods } from '../../queries/useReportGoods';
import { useGoodsBasic } from '../../../../queries/useGoodsBasic';
import { useReportPriceAbusingBottomSheet } from '../ReportPriceAbusingBottomSheet';
import { useLogClickReportPriceAbusing } from '../../hooks/useLogClickReportPriceAbusing';
import { useLogCompleteReportPriceAbusing } from '../../hooks/useLogCompleteReportPriceAbusing';
import { systemAlert } from 'shared/src/component';
import { isNil } from 'shared/src/utils';

export const ReportPriceButton: React.FC = () => {
  const { data: isReportable } = useGoodsReportable();
  const { mutateAsync: reportGoods } = useReportGoods();
  const { data: goodsBasic } = useGoodsBasic();
  const { show: showReportBottomSheet } = useReportPriceAbusingBottomSheet();
  const logClickReportPriceAbusing = useLogClickReportPriceAbusing();
  const logCompleteReportPriceAbusing = useLogCompleteReportPriceAbusing();
  const [isReported, setIsReported] = useState(false);

  const onPressReport = useCallback(async () => {
    logClickReportPriceAbusing();

    if (isReported) {
      systemAlert(
        '이미 제보한 상품이에요',
        '이미 이상 판매가로 제보가 접수되어 검토 중인 상품입니다.',
        [{ text: '확인' }],
      );
      return;
    }

    if (!isReportable || isNil(goodsBasic)) return;

    const result = await showReportBottomSheet({
      goodsImage: goodsBasic.cover_images[0],
      marketName: goodsBasic.market.name,
      goodsName: goodsBasic.name,
      discountRate: goodsBasic.price_info.discount_rate,
      price: goodsBasic.price_info.thumbnail_price,
    });

    if (result.type === 'confirm') {
      try {
        await reportGoods(result.data.comments);
        logCompleteReportPriceAbusing();
        setIsReported(true);
        systemAlert(
          '제보가 접수되었어요',
          '검토 후, 운영정책 위반으로 확인되면 정책에 따라 조치됩니다.',
          [{ text: '확인' }],
        );
      } catch {
        systemAlert(
          '이미 제보한 상품이에요',
          '이미 이상 판매가로 제보가 접수되어 검토 중인 상품입니다.',
          [{ text: '확인' }],
        );
        setIsReported(true);
      }
    }
  }, [
    goodsBasic,
    isReportable,
    isReported,
    logClickReportPriceAbusing,
    logCompleteReportPriceAbusing,
    reportGoods,
    showReportBottomSheet,
  ]);

  if (!isReportable || isNil(goodsBasic)) {
    return null;
  }

  return (
    <Flex.Row justifyContent={'flex-end'}>
      <Flex onPress={onPressReport} padding={{ vertical: 12 }}>
        <Typography
          type={'body4'}
          color={'content_tertiary'}
          textDecorationLine={'underline'}
        >
          최종 가격이 예상과 다른가요?
        </Typography>
      </Flex>
    </Flex.Row>
  );
};
